module.exports = __webpack_public_path__ + "img/tradein-full-3.df92a84f.jpg";